


















































import { Component, Mixins } from "vue-property-decorator";
import mixins from "@/mixins";

@Component
class SurveyIndex extends Mixins(mixins.page) {
  totalScore = 0;

  get title() {
    return this.$t("survey.result") as string;
  }

  get resultMap() {
    return {
      conservative: {
        riskLevel: 1,
        title: this.$t("survey.result.conservative"),
        description: this.$t("survey.result.conservative.description"),
        goal: this.$t("survey.result.conservative.goal")
      },
      robust: {
        riskLevel: 2,
        title: this.$t("survey.result.robust"),
        description: this.$t("survey.result.robust.description"),
        goal: this.$t("survey.result.robust.goal")
      },
      balanced: {
        riskLevel: 3,
        title: this.$t("survey.result.balanced"),
        description: this.$t("survey.result.balanced.description"),
        goal: this.$t("survey.result.balanced.goal")
      },
      growth: {
        riskLevel: 4,
        title: this.$t("survey.result.growth"),
        description: this.$t("survey.result.growth.description"),
        goal: this.$t("survey.result.growth.goal")
      },
      radical: {
        riskLevel: 5,
        title: this.$t("survey.result.radical"),
        description: this.$t("survey.result.radical.description"),
        goal: this.$t("survey.result.radical.goal")
      }
    };
  }

  get curResultKey() {
    let key = "conservative";
    if (this.totalScore > 41) {
      key = "radical";
    } else if (this.totalScore >= 35) {
      key = "growth";
    } else if (this.totalScore >= 30) {
      key = "balanced";
    } else if (this.totalScore >= 25) {
      key = "robust";
    } else if (this.totalScore < 25) {
      key = "conservative";
    }
    return key;
  }

  get curResultTitle() {
    return this.resultMap[this.curResultKey].title;
  }

  get curResultDescription() {
    return this.resultMap[this.curResultKey].description;
  }

  get curResultGoal() {
    return this.resultMap[this.curResultKey].goal;
  }

  get curResultRiskLevel() {
    return this.resultMap[this.curResultKey].riskLevel;
  }

  mounted() {
    const score = this.$route.query.score as string;
    this.totalScore = +score;
  }

  close() {
    this.$helper.toFusionPath(this, "basis", {
      name: "tools"
    });
  }
}
export default SurveyIndex;
